import { AppBar, Box } from '@mui/material';
import * as React from 'react';
import Navbar from './Navbar';

const MainPageLayout = ({ children }) => {
    return <>
        <Navbar AppBarComponent={AppBar} />
        <Box sx={{ background: "white", height: "100vh", width: "100%" }}>
            {children}
        </Box>
    </>
}

export default MainPageLayout